import React from 'react'

import { Pagination } from 'components'
import { TicketDownloadReport } from 'features/Ticket'
import { onPageChange } from 'helpers/common'

import type { IParamTicket } from 'features/Ticket'

interface Props {
  currentPage: number
  totalPage: number
  disabled: boolean
  setSearchParams: (params: IParamTicket) => void
  setPrevPage: (page: number) => void
}

export const TicketPagination: React.FC<Props> = ({
  currentPage,
  totalPage,
  disabled,
  setSearchParams,
  setPrevPage,
}: Props) => {
  const base = 'f-ticket-bottom-con'

  const handlePageChange = (page: number) => {
    onPageChange(() => {
      setSearchParams({ _page: page })
      setPrevPage(page)
    })
  }

  return (
    <div className={base}>
      <TicketDownloadReport />
      <Pagination
        currentPage={currentPage}
        totalPages={totalPage}
        disabled={disabled}
        onChange={handlePageChange}
      />
    </div>
  )
}

export default TicketPagination
